<template>
  <div class="Addperson addCommon" style="height: 100%">
    <div class="return">
      <i class="el-icon-back" @click="goReturn">{{$t('LanguageLib.Return')}}</i>
      <span class="border"></span>
      <span class="title">{{ titleType }}</span>
    </div>
    <div class="content">
      <el-button @click="submit('ruleForm')" type="primary" class="searchBtn" :loading="loadingSave" style="margin-bottom: 7px;">{{$t('LanguageLib.SAVE')}}</el-button>
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="0px" class="ruleForm">
        <h4>{{$t('LanguageLib.BASIC_CONFIGURATION')}}</h4>
        <div class="contentTop">
            <el-checkbox v-model="allowedMultiUser">{{$t('LanguageLib.ALLOW_MULTIPLE_PEOPLE')}}</el-checkbox>
        </div>
        <div class="contentInfo">
          <h4>{{$t('LanguageLib.BASIC_INFORMATION')}}</h4>
          <div class="infoForm">
            <div class="parent">
              <p class="drawerText">{{$t('LanguageLib.SERIAL_NUMBER')}}</p>
              <el-form-item>
                <el-input style="width: 320px;" oninput="this.value=this.value.replace(/[^\d]/g,'');" :placeholder="$t('LanguageLib.PleaseEnter')" v-model="sortNo" maxlength="9">
                </el-input>
              </el-form-item>
            </div>
            <div class="parent">
              <p class="drawerText"><span class="colorRed">*</span>&nbsp;{{$t('LanguageLib.ROLE_NAME')}}</p>
              <el-form-item prop="roleName">
                <el-input style="width: 320px;" :placeholder="$t('LanguageLib.PleaseEnter')" v-model="ruleForm.roleName" maxlength="50">
                </el-input>
              </el-form-item>
            </div>
            <div class="parent">
              <p class="drawerText">{{$t('LanguageLib.ORGANIZATION_TYPE')}}</p>
              <el-form-item>
                <el-select style="width: 320px;" v-model="domainTypeId" filterable  clearable :placeholder="$t('LanguageLib.PLEASE_CHOOSE')">
                  <el-option
                    v-for="item in orgTypeList"
                    :key="item.id"
                    :label="item.domainTypeName"
                    :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </div>
            <div class="parent">
              <p class="drawerText"><span class="colorRed">*</span>&nbsp;{{$t('LanguageLib.USER_TYPE')}}</p>
              <el-form-item prop="rank">
                <el-select style="width: 320px;" v-model="ruleForm.rank" clearable :placeholder="$t('LanguageLib.PLEASE_CHOOSE')">
                  <el-option
                    v-for="item in UserTypeList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </div>
            <div class="parent">
              <p class="drawerText">{{$t('LanguageLib.NUMBER_OF_LEVELS_OF_SUPERIOR_ORGANIZATION_PERSONNEL_ALLOWED_TO_VIEW')}}</p>
              <el-form-item>
                <el-select style="width: 320px;" v-model="upLookDomainLevel" :placeholder="$t('LanguageLib.PLEASE_CHOOSE')">
                  <el-option
                    v-for="item in upLookDomainLevelList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </div>
            <div class="parent">
              <p class="drawerText">{{$t('LanguageLib.REMARK2')}}</p>
              <el-form-item>
                <el-input
                  style="width: 320px;"
                  maxlength="300"
                  type="textarea"
                  :rows="3"
                  placeholder=""
                  resize="none"
                  v-model="description"
                >
                </el-input>
              </el-form-item>
            </div>
          </div>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
import basicdataApi from '../../api/basicdata'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
export default {
  name: 'AddRole',
  data () {
    var checkroleName = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$t('LanguageLib.ROLE_NAME') + this.$t('LanguageLib.CAN_NOT_BE_EMPTY')))
      } else {
        if (this.$commonfun.isNull(value)) {
          return callback(new Error(this.$t('LanguageLib.ROLE_NAME') + this.$t('LanguageLib.CAN_NOT_BE_EMPTY')))
        } else {
          callback()
        }
      }
    }
    var checkrank = (rule, value, callback) => {
      if (value === '') {
        return callback(new Error(this.$t('LanguageLib.USER_TYPE') + this.$t('LanguageLib.CAN_NOT_BE_EMPTY')))
      } else {
        callback()
      }
    }
    return {
      loadingSave: false,
      allowedMultiUser: false, // 允许多人
      sortNo: '', // 序号
      domainTypeId: '', // 组织类型id
      description: '', // 备注
      UserType: '', // 用户类型
      upLookDomainLevel: 0, // 允许查看上级组织人员层数
      orgTypeList: [], // 组织类型列表
      upLookDomainLevelList: [
        {
          value: 0,
          label: 0
        }, {
          value: 1,
          label: 1
        }, {
          value: 2,
          label: 2
        }, {
          value: 3,
          label: 3
        }, {
          value: 4,
          label: 4
        }, {
          value: 5,
          label: 5
        }, {
          value: 6,
          label: 6
        }, {
          value: 7,
          label: 7
        }], // 允许查看上级组织人员层数列表
      UserTypeList: [{
        value: 1,
        label: this.$t('LanguageLib.RETAIL_MANAGEMENT')
      }, {
        value: 2,
        label: this.$t('LanguageLib.STORE_MANAGEMENT')
      }, {
        value: 3,
        label: this.$t('LanguageLib.Store_Staff')
      }, {
        value: 4,
        label: this.$t('LanguageLib.Non_Retail_System')
      }], // 用户类型列表
      titleType: this.$t('LanguageLib.ROLE_INFORMATION'),
      ruleForm: {
        roleName: '', // 角色名称
        rank: '' // 用户类型
      },
      rules: {
        roleName: [{
          validator: checkroleName,
          trigger: 'blur'
        }],
        rank: [{
          validator: checkrank,
          trigger: 'change'
        }]
      }
    }
  },
  beforeRouteEnter (to, from, next) {
    NProgress.configure({
      easing: 'ease',
      speed: 500,
      showSpinner: false,
      trickleSpeed: 200,
      minimum: 0.3
    })
    NProgress.start()
    if (to.query.type === 'edit') {
      var id = JSON.parse(decodeURIComponent(to.query.data)).id
      // 获取组织类型列表
      basicdataApi.getOrgTypeList('get', '/role/domainTypes')
        .then(result => {
          basicdataApi.GetRoleDetail('get', '/role/detail',
            {
              id: id
            })
            .then(res => {
              NProgress.done()
              next(vm => {
                vm.allowedMultiUser = res.data.allowedMultiUser
                vm.sortNo = res.data.sortNo
                vm.ruleForm.roleName = res.data.roleName
                vm.domainTypeId = res.data.domainTypeId
                vm.ruleForm.rank = res.data.rank
                vm.description = res.data.description
                vm.upLookDomainLevel = res.data.upLookDomainLevel
                vm.orgTypeList = result.data
              })
            })
            .catch(err => {
              console.log(err)
            })
        })
        .catch(err => {
          console.log(err)
        })
    } else {
      // 获取组织类型列表
      basicdataApi.getOrgTypeList('get', '/role/domainTypes')
        .then(res => {
          NProgress.done()
          next(vm => {
            vm.orgTypeList = res.data
            vm.ruleForm.rank = ''
          })
        })
        .catch(err => {
          console.log(err)
        })
    }
  },
  created () {
    // 获取角色序号
    basicdataApi.SortNo('get', '/role/sortNo')
      .then(res => {
        if (this.$route.query.type === 'add') {
          this.sortNo = res.data
        }
      })
      .catch(err => {
        this.$commonfun.console.log(err)
      })
  },
  methods: {
    // 返回
    goReturn () {
      var fromPath = this.$route.query.type === 'add' ? 'addRole' : 'editRole'
      this.$router.push('/basicdata/rolesetting?currentPage=' + this.$route.query.currentPage + '&pageSize=' + this.$route.query.pageSize + '&sort=' + this.$route.query.sort + '&searchText=' + this.$commonfun.encodeUrl(this.$route.query.searchText) + '&IsAsc=' + this.$route.query.IsAsc + '&fromPath=' + fromPath)
    },
    // 保存数据
    submit (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // 是否锁定
          this.loadingSave = true
          if (this.$route.query.type === 'add') {
            basicdataApi.AddPerson('post', '/role/create', { allowedMultiUser: this.allowedMultiUser, sortNo: this.sortNo === '' ? null : this.sortNo * 1, roleName: this.$commonfun.trim('tail', this.ruleForm.roleName), domainTypeId: this.domainTypeId === '' ? null : this.domainTypeId, rank: this.ruleForm.rank, upLookDomainLevel: this.upLookDomainLevel, description: this.description })
              .then(res => {
                this.$message({
                  type: 'success',
                  message: this.$t('LanguageLib.ADDED_SUCCESSFULLY1')
                })
                var fromPath = this.$route.query.type === 'add' ? 'addRole' : 'editRole'
                this.$router.push('/basicdata/rolesetting?currentPage=' + this.$route.query.currentPage + '&pageSize=' + this.$route.query.pageSize + '&sort=' + this.$route.query.sort + '&searchText=' + this.$commonfun.encodeUrl(this.$route.query.searchText) + '&IsAsc=' + this.$route.query.IsAsc + '&fromPath=' + fromPath)
                this.loadingSave = false
              })
              .catch(err => {
                this.loadingSave = false
                this.$commonfun.console.log(err)
              })
          } else {
            basicdataApi.editRole('post', '/role/update', { allowedMultiUser: this.allowedMultiUser, sortNo: this.sortNo === '' ? null : this.sortNo * 1, roleName: this.$commonfun.trim('tail', this.ruleForm.roleName), domainTypeId: this.domainTypeId === '' ? null : this.domainTypeId, rank: this.ruleForm.rank, upLookDomainLevel: this.upLookDomainLevel, description: this.description, id: JSON.parse(this.$commonfun.decodeUrl(this.$route.query.data)).id })
              .then(res => {
                this.$message({
                  type: 'success',
                  message: this.$t('LanguageLib.EditSuccess')
                })
                var fromPath = this.$route.query.type === 'add' ? 'addRole' : 'editRole'
                this.$router.push('/basicdata/rolesetting?currentPage=' + this.$route.query.currentPage + '&pageSize=' + this.$route.query.pageSize + '&sort=' + this.$route.query.sort + '&searchText=' + this.$commonfun.encodeUrl(this.$route.query.searchText) + '&IsAsc=' + this.$route.query.IsAsc + '&fromPath=' + fromPath)
                this.loadingSave = false
              })
              .catch(err => {
                this.loadingSave = false
                this.$commonfun.console.log(err)
              })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style lang="scss">
  .Addperson {
    .TeInput input {
      border-right: 0px;
      border-radius: 4px 0 0 4px;
    }
    .return {
      padding-left: 25px;
      position: relative;
      height: 50px;
      background: rgba(255, 255, 255, 1);
      line-height: 50px;
      border-bottom: 1px solid #F2F2F2;
      .el-icon-back {
        margin-right: 15px;
        cursor: pointer;
      }
      .border {
        position: absolute;
        height: 37px;
        border-left: 1px solid #f1f1f1;
        display: inline-block;
        top: 5px;
      }
      .title {
        height: 25px;
        font-size: 18px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 1);
        margin-left: 15px;
      }
    }
    .content::-webkit-scrollbar {
      width: 10px;
      height: 10px;
    }
    .content::-webkit-scrollbar-thumb {
      border-radius: 5px;
      -webkit-box-shadow: inset 0 0 5px rgba(255, 255, 255, 0.2);
      background: #E1E1E1;
    }
    .content::-webkit-scrollbar-track {
      -webkit-box-shadow: inset 0 0 5px rgba(255, 255, 255, 0.2);
      border-radius: 5px;
      background: #fff;
    }
    .content {
      background: rgba(255, 255, 255, 1);
      width: 100%;
      height: calc( 100% - 66px);
      overflow-y: auto;
      padding: 0 100px;
      padding-top: 15px;
      box-sizing: border-box;
      .drawerText {
        margin-bottom: 5px;
        height: 16px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(77, 77, 77, 1);
        line-height: 16px;
      }
      h4 {
        font-size: 16px;
        color: #000;
        font-weight: normal;
        padding-top: 8px;
      }
      .contentTop{
        padding: 15px 0 24px 20px;
        .el-checkbox{
          margin-right: 30px;
        }
      }
      .infoForm {
        padding: 15px 0 0 20px;
        .parent {
          width: 50%;
          vertical-align: top;
          display: inline-block;
        }
      }
    }
     /*修改按钮样式*/
    .el-button--primary {
      background-color: #3BC6B9;
      border-color: #3BC6B9;
      height: 30px;
      padding: 7px 20px;
      margin-bottom: 15px;
      margin-left: 0;
    }
    .colorRed {
      color: red;
    }
    .el-textarea__inner {
      font: 400 13.3333px Arial;
    }
  }
.el-range-editor.el-input__inner{
  width: 320px;
}
.el-textarea{
  textarea{
    height: 124px;
  }
}
</style>
